import React from 'react';
import { CheckCircle2Icon, GiftIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const ITEMS = [{
  text: 'Tomo 01: Mentalidad de Cierre',
  value: '$17.00',
  type: 'core'
}, {
  text: 'Tomo 02: Estructura de Conversación',
  value: '$17.00',
  type: 'core'
}, {
  text: 'Tomo 03: El Poder de las Preguntas',
  value: '$17.00',
  type: 'core'
}, {
  text: 'Tomo 04: El Cierre Maestro',
  value: '$17.00',
  type: 'core'
}, {
  text: 'Tomo 05: Seguimiento Sin Persecución',
  value: '$17.00',
  type: 'core'
}, {
  text: 'Bono 1: Diagnóstico Anti-Visto',
  value: '$27.00',
  type: 'bonus'
}, {
  text: 'Bono 2: Oferta Irresistible en 1 Página',
  value: '$37.00',
  type: 'bonus'
}, {
  text: 'Bono 3: Banco de Prueba Social',
  value: '$27.00',
  type: 'bonus'
}];
export function ValueStack() {
  return <section className="bg-brand-black px-4 py-20 sm:px-6 lg:px-8" data-id="element-246">
      <div className="mx-auto max-w-3xl" data-id="element-247">
        <h2 className="mb-10 text-center text-3xl font-bold text-white sm:text-4xl" data-id="element-248">
          Lo que recibes hoy:
        </h2>

        <div className="overflow-hidden rounded-2xl border border-brand-green/30 bg-brand-darkGray shadow-2xl" data-id="element-249">
          <ul className="divide-y divide-white/10" data-id="element-250">
            {ITEMS.map((item, idx) => <li key={idx} className="flex items-center justify-between p-4 sm:p-6 hover:bg-white/5 transition-colors" data-id="element-251">
                <div className="flex items-center gap-3" data-id="element-252">
                  {item.type === 'core' ? <CheckCircle2Icon className="h-6 w-6 text-brand-green flex-shrink-0" data-id="element-253" /> : <GiftIcon className="h-6 w-6 text-brand-gold flex-shrink-0" data-id="element-254" />}
                  <span className={`text-lg sm:text-xl ${item.type === 'bonus' ? 'text-brand-gold font-medium' : 'text-gray-200'}`} data-id="element-255">
                    {item.text}
                  </span>
                </div>
                <span className="text-lg text-gray-500 line-through" data-id="element-256">
                  {item.value}
                </span>
              </li>)}
          </ul>

          <div className="bg-white/5 p-6 sm:p-8 border-t border-white/10" data-id="element-257">
            <div className="flex items-center justify-between mb-4" data-id="element-258">
              <span className="text-xl font-bold text-gray-400" data-id="element-259">
                VALOR TOTAL REAL
              </span>
              <span className="text-2xl font-bold text-red-400 line-through" data-id="element-260">
                $176.00
              </span>
            </div>
            <div className="flex items-center justify-between mb-8" data-id="element-261">
              <span className="text-2xl font-black text-white sm:text-3xl" data-id="element-262">
                🔥 TU PRECIO HOY
              </span>
              <span className="text-4xl font-black text-brand-green sm:text-5xl" data-id="element-263">
                $13.99
              </span>
            </div>

            <div className="mb-8" data-id="element-264">
              <div className="flex justify-between text-sm text-brand-green mb-2 font-bold" data-id="element-265">
                <span data-id="element-266">Oferta disponible por tiempo limitado</span>
                <span data-id="element-267">85% Reclamado</span>
              </div>
              <div className="h-3 w-full rounded-full bg-white/10 overflow-hidden" data-id="element-268">
                <div className="h-full bg-brand-green w-[85%] rounded-full relative" data-id="element-269">
                  <div className="absolute inset-0 bg-white/20 animate-pulse" data-id="element-270"></div>
                </div>
              </div>
            </div>

            <CTAButton fullWidth className="text-xl py-6" data-id="element-271">
              OBTENER TODO POR $13.99 AHORA
            </CTAButton>
          </div>
        </div>
      </div>
    </section>;
}